import { PPCPositionTypesUK, PPCPositionTypes } from '@as-react/common-types';
export const getPPCPositionTypesByMarket = (market) => {
    switch (market) {
        case 'uk':
            return PPCPositionTypesUK;
        default:
            return PPCPositionTypes;
    }
};
